// Phase 999.6 Plan 03 — ActionName metadata map for the UserLogViewer.
//
// Provides a human-readable label and Bootstrap row-colour class for every
// ActionName that originates from Home.js postUserLog call sites plus the
// forensic AuditAndDiag path tokens (PushPlan / Update2 / dispatch-published).
//
// colour values map to Bootstrap 5 contextual table classes (table-{colour}).
// Forensic tokens have color: null — severity drives their row class.
//
// CATEGORIES is the source-of-truth list for the category filter dropdown.
// categoryToActionNameLike translates a category value to the ActionName LIKE
// token the server expects (e.g. 'plan-upload' → 'Plan%').
//
// Named exports only — no default export, no React import.

export const ACTION_MAP = {
    // Plan operations
    'Plan File Upload':          { label: 'File uploaded',          category: 'plan-upload',  color: 'info'      },
    'Plan Upload Submit New':    { label: 'Plan submitted (new)',    category: 'plan-upload',  color: 'info'      },
    'Plan Upload Submit Update': { label: 'Plan submitted (update)', category: 'plan-upload',  color: 'info'      },
    'Plan Export Data':          { label: 'Plan data exported',      category: 'plan-upload',  color: 'secondary' },
    'Redrill Upload Submit':     { label: 'Redrill uploaded',        category: 'plan-upload',  color: 'info'      },

    // Shot / site administration
    'SubSequence Insert':        { label: 'Shot created',           category: 'shot-admin',   color: 'success'   },
    'SubSequence Archive':       { label: 'Shot archived',          category: 'shot-admin',   color: 'warning'   },
    'SubSequence Delete':        { label: 'Shot deleted',           category: 'shot-admin',   color: 'warning'   },
    'SubSequence Rename':        { label: 'Shot renamed',           category: 'shot-admin',   color: 'secondary' },
    'SubLocation Insert':        { label: 'Bench created',          category: 'shot-admin',   color: 'success'   },
    'SubLocation Archive':       { label: 'Bench archived',         category: 'shot-admin',   color: 'warning'   },
    'SubLocation Delete':        { label: 'Bench deleted',          category: 'shot-admin',   color: 'warning'   },
    'SubLocation Rename':        { label: 'Bench renamed',          category: 'shot-admin',   color: 'secondary' },
    'Sequence Insert':           { label: 'Pit created',            category: 'shot-admin',   color: 'success'   },
    'Sequence Archive':          { label: 'Pit archived',           category: 'shot-admin',   color: 'warning'   },
    'Sequence Delete':           { label: 'Pit deleted',            category: 'shot-admin',   color: 'warning'   },
    'Sequence Rename':           { label: 'Pit renamed',            category: 'shot-admin',   color: 'secondary' },

    // Review / dispatch
    'Review Insert':             { label: 'Review submitted',       category: 'dispatch',     color: 'secondary' },
    'Review Reset Assignments':  { label: 'Review reset',           category: 'dispatch',     color: 'warning'   },
    'Review Approve':            { label: 'Review approved',        category: 'dispatch',     color: 'success'   },

    // Auth
    'login':                     { label: 'User login',             category: 'auth',         color: 'secondary' },

    // Forensic tokens (AuditAndDiag path) — severity drives row colour; color: null signals this.
    'PushPlan':                  { label: 'Plan sync (PushPlan)',   category: 'dispatch',     color: null        },
    'Update2':                   { label: 'Plan update (Update2)',  category: 'dispatch',     color: null        },
    'dispatch-published':        { label: 'Dispatch published',     category: 'dispatch',     color: null        },
};

export const CATEGORIES = [
    { value: '',            label: '(all)'           },
    { value: 'plan-upload', label: 'Plan uploads'    },
    { value: 'shot-admin',  label: 'Shot/site admin' },
    { value: 'dispatch',    label: 'Dispatch'        },
    { value: 'auth',        label: 'Auth'            },
];

/**
 * Returns the ActionName LIKE token to pass to the server for a given category.
 * An empty category ('') returns '' (no filter applied).
 *
 * The server's buildQueryString sets `params.set('actionName', token)` when
 * filters.category is set and filters.actionName is empty.
 *
 * @param {string} category - One of the CATEGORIES values.
 * @returns {string} LIKE token suitable for the server actionName param.
 */
export function categoryToActionNameLike(category) {
    switch (category) {
        case 'plan-upload': return 'Plan%';
        case 'shot-admin':  return '%Sequence%';
        case 'dispatch':    return 'dispatch%';
        case 'auth':        return 'login%';
        default:            return '';
    }
}
